import { StrictMode } from 'react'
import './i18n'
import './lib/api'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const CHUNK_RELOAD_KEY = 'vitacare-admin:chunk-reload-at'

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()

  const now = Date.now()
  const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0)
  if (now - lastReloadAt < 10_000) return

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
  window.location.reload()
})

window.addEventListener('load', () => {
  window.setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY), 10_000)
}, { once: true })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
